// Router
import { cTEMA_VENDAS_ROUTES } from '@/router/temas/rotasTemaVendas';
import { cTEMA_ESTOQUE_ROUTES } from '@/router/temas/rotasTemaEstoque';
import { cTEMA_FINANCEIRO_ROUTES } from '@/router/temas/rotasTemaFinanceiro';

// Enums
import ECodificacao from '../enums/ECodificacao';

// Types
import type { TMenuSibebar } from '@/stores/TemaStore';
import type { TConfigTema } from '../types/TConfigTema';

// Constantes
import cMENUS_TEMA_VENDAS from '@/modules/temas/tema-vendas/MenusTemaVendas';
import cMENUS_TEMA_ESTOQUE from '@/modules/temas/tema-estoque/MenusTemaEstoque';
import cMENUS_TEMA_FINANCEIRO from '@/modules/temas/tema-financeiro/MenusTemaFinanceiro';

// Json Menus
import jsonMenus from '../../assets/data/menus_dashboards.json';

export const cCONFIG_TEMA_INDEFINIDO: TConfigTema = {
  codificacao: ECodificacao.Indefinido,
  titulo: '',
  subtitulo: '',
  rota: '',
  icone: '',
  cor: '',
  cadastraParametro: false,
  rotaPersonalizado: '',
};

export const cCONFIG_TEMA_ADMINISTRATIVO: TConfigTema = {
  codificacao: ECodificacao.TemaAdministrativo,
  titulo: 'Administrativo',
  subtitulo: '',
  rota: '',
  icone: 'mdi-security',
  cor: '',
  rotaPersonalizado: '',
  cadastraParametro: false,
};

export const cCONFIG_TEMA_VENDAS: TConfigTema = {
  cadastraParametro: true,
  codificacao: ECodificacao.TemaVendas,
  titulo: jsonMenus.temaVendas.titulo,
  subtitulo: 'Movimentação de Vendas',
  rota: cTEMA_VENDAS_ROUTES.name,

  icone: jsonMenus.temaVendas.icone,
  cor: jsonMenus.temaVendas.corIcone,
  rotaPersonalizado: cTEMA_VENDAS_ROUTES.Personalizado.Dashboard.name,
};

export const cCONFIG_SUBTEMA_META_VENDAS: TConfigTema = {
  cadastraParametro: false,
  codificacao: ECodificacao.SubtemaMetaVendas,
  titulo: 'Meta de Vendas',
  subtitulo: '',
  rota: '',
  icone: 'mdi-bullseye-arrow',
  cor: jsonMenus.temaVendas.corIcone,
  rotaPersonalizado: '',
};

export const cCONFIG_TEMA_FINANCEIRO: TConfigTema = {
  cadastraParametro: true,
  codificacao: ECodificacao.TemaFinanceiro,
  titulo: jsonMenus.temaFinanceiro.titulo,
  subtitulo: 'Movimentação Financeira',
  rota: cTEMA_FINANCEIRO_ROUTES.name,
  icone: jsonMenus.temaFinanceiro.icone,
  cor: jsonMenus.temaFinanceiro.corIcone,
  rotaPersonalizado: cTEMA_FINANCEIRO_ROUTES.Personalizado.Dashboard.name,
};

export const cCONFIG_TEMA_ESTOQUE: TConfigTema = {
  cadastraParametro: true,
  codificacao: ECodificacao.TemaEstoque,
  titulo: jsonMenus.temaEstoque.titulo,
  subtitulo: 'Movimentação de Estoque',
  rota: cTEMA_ESTOQUE_ROUTES.name,
  icone: jsonMenus.temaEstoque.icone,
  cor: jsonMenus.temaEstoque.corIcone,
  rotaPersonalizado: cTEMA_ESTOQUE_ROUTES.Personalizado.Dashboard.name,
};

export const cCONFIG_SUBTEMA_PEDIDO_COMPRA: TConfigTema = {
  cadastraParametro: false,
  codificacao: ECodificacao.SubtemaPedidoCompra,
  titulo: 'Pedidos de Compra',
  subtitulo: '',
  rota: '',
  icone: 'mdi-file-sign',
  cor: jsonMenus.temaEstoque.corIcone,
  rotaPersonalizado: '',
};

export const cCONFIG_TEMA_PRODUCAO: TConfigTema = {
  cadastraParametro: true,
  codificacao: ECodificacao.Indefinido,
  titulo: jsonMenus.temaProducao.titulo,
  subtitulo: '',
  rota: '',
  icone: jsonMenus.temaProducao.icone,
  cor: jsonMenus.temaProducao.corIcone,
  rotaPersonalizado: '',
};

export function obterConfigTema(pCodificacao: ECodificacao): TConfigTema {
  switch (pCodificacao) {
    case ECodificacao.TemaVendas:
      return cCONFIG_TEMA_VENDAS;

    case ECodificacao.SubtemaMetaVendas:
      return cCONFIG_SUBTEMA_META_VENDAS;

    case ECodificacao.TemaFinanceiro:
      return cCONFIG_TEMA_FINANCEIRO;

    case ECodificacao.TemaEstoque:
      return cCONFIG_TEMA_ESTOQUE;

    case ECodificacao.TemaAdministrativo:
      return cCONFIG_TEMA_ADMINISTRATIVO;

    case ECodificacao.SubtemaPedidoCompra:
      return cCONFIG_SUBTEMA_PEDIDO_COMPRA;

    default:
      throw `A codificação "${pCodificacao}" não existe ou não foi mapeada na função "obterConfigTema".`;
  }
}

/**
 * Constante utilizada para renderização de todos os temas disponiveis
 * - Utilizado na listagem de temas
 */
export const cTEMAS = [cCONFIG_TEMA_VENDAS, cCONFIG_TEMA_FINANCEIRO, cCONFIG_TEMA_ESTOQUE, cCONFIG_TEMA_PRODUCAO];

/**
 * Constante que armazena as rotas correspondentes aos personalizados dos temas
 * para a correta gravação de preferências (Arquivo .ini)
 *
 * Gualter: Utilizado dessa forma para não criar "Menus Falsos/Virtuais" no dashboard para essa finalidade
 */
export const cROTAS_DASHBOARDS_PERSONALIZADOS = [
  cTEMA_VENDAS_ROUTES.Personalizado.Dashboard.name,
  cTEMA_FINANCEIRO_ROUTES.Personalizado.Dashboard.name,
  cTEMA_ESTOQUE_ROUTES.Personalizado.Dashboard.name,
];

/**
 * Constante utilizada para renderizar todos os menus de determinado dashbaord/tema.
 * - Utilizada no perfil de acesso
 */
export const cMENUS_DE_TODOS_TEMAS: TMenuSibebar[] = [
  {
    id: jsonMenus.temaVendas.id,
    ...cCONFIG_TEMA_VENDAS,
    children: cMENUS_TEMA_VENDAS,
    nameRoute: '',
  },
  {
    id: jsonMenus.temaFinanceiro.id,
    ...cCONFIG_TEMA_FINANCEIRO,
    children: cMENUS_TEMA_FINANCEIRO,
    nameRoute: '',
  },
  {
    id: jsonMenus.temaEstoque.id,
    ...cCONFIG_TEMA_ESTOQUE,
    children: cMENUS_TEMA_ESTOQUE,
    nameRoute: '',
  },
];

/**
 * Função recursiva que retorna a lista de menus/rotas que dizem respeito a dashboards
 * menosprezando os menus pai
 * @param menu
 * @returns
 */
function getApenasMenusDeDashboards(menu: TMenuSibebar[]): string[] {
  const getNameRoute = (item: TMenuSibebar): string[] => {
    if (item.children?.length) {
      return item.children.flatMap(getNameRoute);
    }

    return item.nameRoute ? [item.nameRoute] : [];
  };

  return menu.flatMap(getNameRoute);
}

/**
 * Constante que contém apenas os menus/rotas que correspondem a dashboards.
 *
 * - Utilizado para determinar se a rota deve ou não gravar as preferências (Arquivo .ini)
 */
export const cMENUS_DASHBOARDS_DE_TODOS_TEMAS: string[] = [
  ...getApenasMenusDeDashboards(cMENUS_DE_TODOS_TEMAS),
  ...cROTAS_DASHBOARDS_PERSONALIZADOS,
];
